import React from "react";
import { Fee } from "./types";

interface FeeCardProps {
  fee: Fee;
  index: number;
}

const FeeCard: React.FC<FeeCardProps> = ({ fee, index }) => {
  return (
    <div className="col-12 col-md-6 col-lg-4 mb-4" key={`${fee.student_name}-${index}`}>
      <div className="card fee-card h-100 shadow-sm">
        <div className="card-header bg-white d-flex justify-content-between align-items-center">
          <h6 className="mb-0">{fee.student_name}</h6>
          <span className={`badge ${fee.balance === "$0.00" ? "bg-success" : "bg-warning"}`}>
            {fee.balance === "$0.00" ? "La Bixiyay" : "Haray"}
          </span>
        </div>
        <div className="card-body">
          <div className="mb-2">
            <small className="text-muted">Fasalka</small>
            <p className="mb-0">{fee.class_name}</p>
          </div>
          <div className="mb-2">
            <small className="text-muted">Bisha</small>
            <p className="mb-0">{fee.month}</p>
          </div>
          <div className="row mb-2">
            <div className="col-6">
              <small className="text-muted">Wadarta Lacagta</small>
              <p className="mb-0 fw-bold">{fee.total_amount}</p>
            </div>
            <div className="col-6">
              <small className="text-muted">Lacagta La Bixiyay</small>
              <p className="mb-0">{fee.amount_paid}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <small className="text-muted">Taariikhda Bixinta</small>
              <p className="mb-0">{fee.date_paid}</p>
            </div>
            <div className="col-6">
              <small className="text-muted">Haraaga</small>
              <p className={`mb-0 ${fee.balance !== "$0.00" ? "text-danger fw-bold" : "text-success"}`}>
                {fee.balance}
              </p>
            </div>
          </div>
        </div>
        <div className="card-footer bg-white">
          <small className="text-muted">Waxaa Qaaday: {fee.collected_by}</small>
        </div>
      </div>
    </div>
  );
};

export default FeeCard;